import { CardTheme, FixedCard } from '../../../elements/molecules/card/Card';

export function OsasFlexQuestionnairesCard() {
    return (
        <FixedCard
            body={
                'Je slaaparts heeft wat vragen over je slaapklachten. Hoe gaat het met je? Beschrijf je huidige klachten.'
            }
            buttonsText={['Beantwoord vragen']}
            cardTitle={'Vragen van je slaaparts'}
            linksTo={[`/osas/questionnaires`]}
            theme={CardTheme.white}
        />
    );
}
